import {
  TREATMENT_GET_REQUEST,
  TREATMENT_GET_SUCCESS,
  TREATMENT_GET_FAILURE,
  TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_REQUEST,
  TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_SUCCESS,
  TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_FAILURE,
  TREATMENT_DETAILS_GET_REQUEST,
  TREATMENT_DETAILS_GET_SUCCESS,
  TREATMENT_DETAILS_GET_FAILURE,
} from '../../../actions/constants/types';

const initialState = {
  isFetching: false,
  treatment: null,
  futureInstances: [],
  hasCompletedVisitToday: false,
};

function previewedTreatment(state = initialState, action) {
  switch (action.type) {
    case TREATMENT_GET_REQUEST:
      return {
        ...state,
        treatment: null,
        isFetching: true,
      };
    case TREATMENT_GET_SUCCESS:
      return {
        ...state,
        treatment: action.response.data.treatment,
        isFetching: false,
      };
    case TREATMENT_GET_FAILURE:
      return {
        ...state,
        treatment: null,
        isFetching: false,
      };
    case TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_SUCCESS:
      return {
        ...state,
        futureInstances: action.response.data.futureAssignedTreatmentInstances,
        hasCompletedVisitToday: action.response.data.hasCompletedVisitToday,
        isFetching: false,
      };
    case TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_FAILURE:
      return {
        ...state,
        futureInstances: null,
        hasCompletedVisitToday: false,
        isFetching: false,
      };
    case TREATMENT_DETAILS_GET_SUCCESS:
      return {
        ...state,
        futureInstances: action.response.data.futureAssignedTreatmentInstances,
        treatment: action.response.data.treatment,
        isFetching: false,
      };
    case TREATMENT_DETAILS_GET_FAILURE:
      return {
        ...state,
        treatment: null,
        futureInstances: null,
        isFetching: false,
      };
    case TREATMENT_DETAILS_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
        treatment: null,
      };
    default:
      return state;
  }
}

export default previewedTreatment;
